const NOT_FOUND_ROBOTS_CONTENT = 'noindex, follow';

function parseDate(value: string | null | undefined): Date | null {
  if (!value) return null;

  const normalizedValue = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value) ? `${value.replace(' ', 'T')}Z` : value;
  const date = new Date(normalizedValue);

  if (Number.isNaN(date.getTime())) return null;

  return date;
}

export function getEmptyHomeQueryRedirectLocation(url: string | null | undefined) {
  return url === '/?' ? '/' : null;
}

export function toHttpDate(value: string | null | undefined) {
  return parseDate(value)?.toUTCString() ?? null;
}

export function getLatestPublicPageLastModified(...lastModifiedValues: (string | null | undefined)[]) {
  let latestValue: string | null = null;
  let latestTime = Number.NEGATIVE_INFINITY;

  for (const value of lastModifiedValues) {
    const date = parseDate(value);

    if (!date) continue;

    const time = date.getTime();

    if (time > latestTime) {
      latestValue = value ?? null;
      latestTime = time;
    }
  }

  return latestValue;
}

export function isPublicPageNotModified(
  lastModified: string | null | undefined,
  ifModifiedSince: string | null | undefined,
) {
  const lastModifiedDate = parseDate(lastModified);
  const ifModifiedSinceDate = parseDate(ifModifiedSince);

  if (!lastModifiedDate || !ifModifiedSinceDate) return false;

  return Math.floor(ifModifiedSinceDate.getTime() / 1000) >= Math.floor(lastModifiedDate.getTime() / 1000);
}

export function getPublicPageLastModifiedHeaders(lastModified: string | null | undefined) {
  const httpDate = toHttpDate(lastModified);

  if (!httpDate) return {};

  return { 'Last-Modified': httpDate };
}

export function getNotFoundRobotsContent() {
  return NOT_FOUND_ROBOTS_CONTENT;
}
